import { I18nThemed } from 'interfaces/mixins';
import { DNode } from '@dojo/framework/core/interfaces';
import { v, w } from '@dojo/framework/core/vdom';
import { Radio } from '@dojo/widgets/radio';

import { FormSelectionField } from '../interfaces';
import css from '../css/form.m.css';

export interface FormSelectionProperties extends FormSelectionField {}

export class FormSelection extends I18nThemed<FormSelectionProperties> {
	protected render(): DNode {
		const { title: labeltext, id: name, fgFormat, fgVocabulary, formdata } = this.properties;
		const label = v('legend', { for: name }, [labeltext]);

		let kids: DNode[] = [];
		if (fgFormat === 'radio') {
			kids = fgVocabulary.map((item) => {
				const parts = item.split('|');
				const value = parts[0];
				const label = parts[parts.length - 1];
				const checked = value === formdata[name];
				return w(
					Radio,
					{
						aria: { checked: `${checked}`, role: 'radio', label: label },
						name,
						checked,
						value,
						onValue: (checked: boolean) => {
							if (checked) {
								formdata[name] = value;
							}
							this.invalidate();
						}
					},
					[{ label }]
				);
				// return v('label', {}, [label, v('input', { name, type: 'radio', value })]);
			});
			return v('fieldset', { classes: [this.theme(css.formRadioFieldset)] }, [
				label,
				v('div', { role: 'radiogroup', classes: ['fg-selection-field'] }, kids)
			]);
		} else {
			return v('p', { style: { color: 'red' } }, [`Processor doesn't understand fgFormat=${fgFormat}`]);
		}
	}
}
